import React from 'react';
import styled from 'styled-components';

const TextWrapper = styled.div`
  font-size: 16px;
  line-height: 1;
  font-weight: 500;
`;

export interface IHeaderThemeLogoTextProps
  extends React.HTMLAttributes<HTMLDivElement> {}
/**
 * Testo nome dell'applicativo.
 */
export function HeaderThemeLogoText(props: IHeaderThemeLogoTextProps) {
  return <TextWrapper {...props} />;
}
